export const isNonEmptyString = (val: unknown) => typeof val === 'string' && val.trim().length > 0;

export const noop = (...args: any[]): undefined => {
  return;
};

export const getErrorMessage = (e?: Error): string => (e && e.message) || '';
